<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03"
                    aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-brand size-height bg-white text-center d-none d-sm-block sidebar"><img
                    src="@/assets/sist-logo.png" alt="Logo Sistema de Obras" width="100"><br><span>{{cliente}}</span></div>

            <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
                <ul class="navbar-nav mr-auto mt-2 mt-lg-0"></ul>
                <button class="btn my-sm-0 text-white mr-3" @click="editarUsuario" title="Editar"><i class="fas fa-cog"></i></button>
                <span class="mr-5 text-white text-uppercase">{{usuario}}</span>
                <button class="btn my-2 my-sm-0 text-white" @click="deslogar" title="Deslogar"><i class="fas fa-sign-out-alt"></i>
                </button>
                <div id="barraConecta"></div>
            </div>
        </nav>
        <div class="menu-semiTop"></div>
    </div>

</template>

<script>


    export default {
        name: 'Cabecalho',

        data() {
            return {
                cliente: 'COTIA',
                usuario: Store.state.usuarioAtual.ba01_nome
            }
        },

        methods: {
            editarUsuario: function () {
                this.$router.push('/usuario/editar');
            },

            deslogar: function () {
                Store.dispatch('deslogar');
                this.$router.push('/login');
            }
        },

        mounted() {
            $.ajax({
                url: "http://api.controle.lliege.com.br/api/controleacesso/barra-lliege-conecta-bootstrap-4/1/2",
                success: function(dados){
                    $('#barraConecta').append(dados);
                }
            });
        }
    }
</script>

<style scoped>
    nav {
        background-color: #999 !important;
        height: 50px;
    }

    .size-height {
        height: 140px;
        width: 255px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
    }

    .menu-semiTop {
        width: 100%;
        height: 90px;
        background-color: #ccc;
    }
    
    .sidebar {
    transition: all 0.3s;
    cursor: pointer;
    }

    .sidebar img{
        transition: all 0.3s;
    }

    .sidebar.active {
        margin-left: -190px;
    }

    .sidebar.active img{
        float: right;
        width: 70px;
        margin-top: 20px;
    }

    .sidebar.active span{
        float: right;
        font-size: 15px;
        margin-left: 168px;
        margin-right: 12px;
    }

    .btn:focus {
        box-shadow: none;
    }
</style>

